import React, { useEffect, useState } from "react";
import { logResponse } from "../utils/logger";
import iconPay from "../assets/img/icon_pay.svg";
import { fetchGetPointHistories, fetchGetCustomer } from "../api";

const Point = () => {
  const [histories, setHistories] = useState([]);
  const [currentPoint, setCurrentPoint] = useState(0);
  const [unshippedPoint, setUnshippedPoint] = useState(0);

  useEffect(() => {
    const access_token = localStorage.getItem("access_token");

    if (!access_token) return;
      logResponse("token:", access_token);

    // 保有ポイント取得
    fetchGetCustomer(access_token).then((data) => {
      logResponse("res1:", data);
      if (data && typeof data.total_points === "number") {
        setCurrentPoint(data.total_points);
      }
      if (data && typeof data.unshipped_points === "number") {
        setUnshippedPoint(data.unshipped_points);
      }
    });

    // 履歴取得
    fetchGetPointHistories(access_token).then((data) => {
      logResponse("res2:", data);
      if (Array.isArray(data)) {
        setHistories(data);
      }
    });
  }, []);

  return (
    <section className="section point-section">
      <h2 className="section-title">
        <i>
          <img src={iconPay} alt="" />
        </i>
        ポイント履歴
      </h2>

      <div className="point-group">
        <div className="group-wrapper">
          <p className="point-title">保有ポイント</p>
          <p className="point-num">
            <span className="num">{currentPoint}</span> ポイント
          </p>
          {unshippedPoint > 0 && (
          <p className="point-unshipped">（ 利用予定ポイント：{unshippedPoint}ポイント ）</p>
          )}
          <div className="point-link">
            <a href="/regular">ポイントを利用する</a>
          </div>
        </div>

        <div className="point-wrapper">
          {histories.length > 0 ? (
            histories.map((item, index) => {
              const isPlus = item.point_delta > 0;
              const isPending = item.is_confirmed === false;
              const formattedDate = new Date(item.issued_date).toLocaleDateString("ja-JP", {
                year: "numeric",
                month: "long",
                day: "numeric"
              });

              return (
                <div className="point" key={item.sequence_number || index}>
                  <div className="flex middle">
                    <div className="info">
                      <div className="date">{formattedDate}</div>
                      <div className={`num ${isPlus ? "plus" : ""}`}>
                        {isPending && <span className="option">(入金後獲得予定)</span>}
                        {isPlus
                          ? `＋ ${item.point_delta}ポイント`
                          : `ー ${Math.abs(item.point_delta)}ポイント`}
                      </div>
                    </div>
                    <div className="action">{item.category_name}</div>
                  </div>
                </div>
              );
            })
          ) : (
            <p>ポイント履歴がありません。</p>
          )}
        </div>
      </div>
    </section>
  );
};

export default Point;
